<template>
    <RedesignBasePopover
        :visible-arrow="false"
        popper-class="volume-badge-popover"
        trigger="hover"
        width="96"
    >
        <template #reference>
            <span
                class="inline-flex rounded items-center justify-center cursor-pointer focus:ring-1 focus:ring-active-elements outline-none"
            >
                <i
                    class="vc-icon-sound-off text-primary-actions icon-xl"
                    :class="isSoundMuted ? 'vc-icon-sound-off' : 'vc-icon-sound-low'"
                    @click="operationWithMute"
                />
            </span>
        </template>
        <div
            class="volume-input-block"
        >
            <input
                v-model="soundVolume"
                type="range"
                min="0"
                max="1"
                step="0.2"
                class="range-input"
                :style="{
                    backgroundSize: `${soundVolume * 100}% 100%`
                }"
            >
        </div>
    </RedesignBasePopover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import RedesignBasePopover from '@/components/RedesignBaseComponents/RedesignBasePopover.vue'
import {
    isSoundMuted,
    soundMutedState,
    soundVolumeState,
    soundVolumeStateValue,
    updateSoundMutedState
} from '@/composables/useSoundsStoreData'

const soundVolume = computed({
    get () {
        return soundVolumeStateValue.value
    },
    set (val) {
        soundVolumeState.value = val
    }
})

function operationWithMute () {
    updateSoundMutedState(!soundMutedState.value)
}
</script>

<style lang="scss">
.volume-badge-popover {
    @apply flex items-center;
    .range-input {
        -webkit-appearance: none;
        width: 100%;
        height: 4px;
        background: var(--ui-lines);
        border-radius: 5px;
        background-size: 70% 100%;
        background-image: linear-gradient(var(--active-elements), var(--active-elements));
        background-repeat: no-repeat;

        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            height: 12px;
            width: 12px;
            border-radius: 50%;
            background: var(--active-elements);
            cursor: pointer;
            box-shadow: 0 0 2px 0 #555;
            transition: background .3s ease-in-out;

            &:hover {
                background-color: var(--active-elements--focus);
            }
        }

        &::-webkit-slider-runnable-track {
            -webkit-appearance: none;
            box-shadow: none;
            border: none;
            background: transparent;
        }

    }
}

.redesign-popover.volume-badge-popover {
    @apply max-h-12 overflow-y-auto p-2 min-w-20;
}

[dir='rtl'] {
    .volume-badge-popover {
        .range-input {
            transform: rotate(180deg);
            background-position: right center;
        }
    }
}
</style>
